module.exports = __webpack_public_path__ + "img/icon_code.281bfb90.jpg";